import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CounterState {
    model:[],
    audioList:[]
}

const initialState: CounterState = {
    model: [],
    audioList: [],
};

export const counterSlice = createSlice({
    name: 'counter',
    initialState,
    reducers: {
        setModelList: (state, action: PayloadAction<any>) => {
            state.model = action.payload;
        },
        setStoreAudioList: (state, action: PayloadAction<any>) => {
            state.audioList = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const { setModelList, setStoreAudioList } = counterSlice.actions;

export default counterSlice.reducer;
